import type {
  AppRouterInstance,
  PrefetchOptions
} from 'next/dist/shared/lib/app-router-context.shared-runtime';

import { isDebug } from './host';

export const PA_BASE_PATH = '/';

export enum ROUTER_PATH {
  personalAI = `/`,

  personalAICreate = `/create`,
  personalAIMemory = `/memories`,
  personalAIMemoryDetail = `/memory/detail`,
  personalAIMemoryCategory = `/memories/category`,
  personalAITodoCanvasDetail = `/todo/detail`,
  personalAIMemoryWiki = `/memories/wiki`,
  personalAIMemoryWikiDetail = `/memories/wiki/detail`,
  personalAIMemoryKey = `/memories/key`,

  homepage = `/:route`,
  userInfoHomepage = '/p/:route',

  auth = '/auth',
  over = '/over',
  log = '/log/:sessionId',
  chat = '/chat/:sessionId',
  group = '/group/:route',

  invite = '/invite/:inviteCode', // 邀请注册处理逻辑
  login = '/login',

  note = '/note/:noteId',
  memory = '/memory/:noteId',
  public = '/public/:noteId',

  talks = '/talks',
  talksCreate = '/talks/create',
  talksDetail = '/talks/detail',
  talk = '/talk/:token',
  presentation = '/presentation/:token',

  friends = '/friends',
  friendsStranger = '/friends/stranger',
  friendsRequest = '/friends/request',
  friendsAdd = '/friends/add',

  personalAIMobile = '/home-mobile',
  personalAIMemoryDetailMobile = '/memory-mobile/detail',
  personalAIMemoryMobile = '/memories-mobile',
  personalAIMemoryCategoryMobile = `/memories-mobile/category`,
  personalAITodoCanvasDetailMobile = `/todo-mobile/detail`,
  personalAIMemoryWikiMobile = `/memories-mobile/wiki`,
  personalAIMemoryWikiDetailMobile = `/memories-mobile/wiki/detail`,
  personalAIMemoryKeyMobile = `/memories-mobile/key`,

  talksMobile = '/talks-mobile',
  talksDetailMobile = '/talks-mobile/detail',
  talksCreateMobile = '/talks-mobile/create',

  booth = '/booth/:token',
  boothCreateMobile = '/booth-mobile/create',
  boothCreate = '/booth/create',

  friendsMobile = '/friends-mobile',
  friendsAddMobile = '/friends-mobile/add',
  friendsRequestMobile = '/friends-mobile/request',
  friendsStrangerMobile = '/friends-mobile/stranger',

  offer = '/offer/:token',
  offerCreate = '/offer/create',
  offerCreating = '/offer/creating',

  rizz = '/rizz/:token',
  rizzCreate = '/rizz/create',
  rizzCreating = '/rizz/creating',

  circle = '/circle/:route'
}

// 修改注意：默认页面需要手动支持：在「当前」页面弹窗登录时，重新请求页面数据（location.reload() 比较重）。
export const DEFAULT_ROUTER = ROUTER_PATH.personalAI;

export const prefetch = (
  router: AppRouterInstance,
  href: string,
  options?: PrefetchOptions
): void => {
  if (!isDebug()) {
    router.prefetch(href, options);
  }
};

export { generatePath } from '@remix-run/router';

export const generateParams = (path: string, params: Record<string, string>): string => {
  const urlParams = new URLSearchParams(params).toString();

  return `${path}?${urlParams}`;
};

const ROUTER_PATHS = Object.values(ROUTER_PATH).map((path) => {
  // 使用正则表达式提取路径中"/"后的内容
  const match = path.match(/^\/([^/:]*)/);

  return match ? match[0].replace(/^\//, '') : path;
});

// 额外的系统保留路径
const SYSTEM_RESERVED_PATHS = ['api', '_next', 'static', 'favicon', 'robots', 'sitemap'];

// 合并所有保留路由
export const RESERVED_ROUTES = [...ROUTER_PATHS, ...SYSTEM_RESERVED_PATHS];

// 检查路径是否为保留路由
export function isReservedRoute(path: string): boolean {
  return RESERVED_ROUTES.includes(path);
}
